import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './AuthContext.jsx';
import { Protected } from './components/Protected.jsx';

import PublicLayout from './routes/PublicLayout.jsx';
import Home from './routes/Home.jsx';
import Login from './routes/Login.jsx';
import Signup from './routes/Signup.jsx';
import Profile from './routes/Profile.jsx';
import Schedule from './routes/Schedule.jsx';
import Shop from './routes/Shop.jsx';
import Join from './routes/Join.jsx';
import Rent from './routes/Rent.jsx';
import Unsubscribe from './routes/Unsubscribe.jsx';
import { CheckoutSuccess, CheckoutCancel, RentalConfirmed } from './routes/CheckoutResult.jsx';

import AdminLayout from './routes/admin/AdminLayout.jsx';
import Dashboard from './routes/admin/Dashboard.jsx';
import Users from './routes/admin/Users.jsx';
import Teams from './routes/admin/Teams.jsx';
import Players from './routes/admin/Players.jsx';
import Events from './routes/admin/Events.jsx';
import Bookings from './routes/admin/Bookings.jsx';
import Products from './routes/admin/Products.jsx';
import Campaigns from './routes/admin/Campaigns.jsx';
import JoinRequests from './routes/admin/JoinRequests.jsx';
import ContactMessages from './routes/admin/ContactMessages.jsx';
import NewsPosts from './routes/admin/NewsPosts.jsx';
import Meetings from './routes/admin/Meetings.jsx';
import Contacts from './routes/admin/Contacts.jsx';
import Lists from './routes/admin/Lists.jsx';
import SignupFields from './routes/admin/SignupFields.jsx';
import StripeSettings from './routes/admin/StripeSettings.jsx';
import EmailSettings from './routes/admin/EmailSettings.jsx';
import RentalPricing from './routes/admin/RentalPricing.jsx';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route index element={<Home />} />
            <Route path="login" element={<Login />} />
            <Route path="signup" element={<Signup />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="shop" element={<Shop />} />
            <Route path="join" element={<Join />} />
            <Route path="rent" element={<Rent />} />
            <Route path="unsubscribe" element={<Unsubscribe />} />
            <Route path="checkout/success" element={<CheckoutSuccess />} />
            <Route path="checkout/cancel" element={<CheckoutCancel />} />
            <Route path="rental/confirmed" element={<RentalConfirmed />} />
            <Route
              path="profile"
              element={
                <Protected>
                  <Profile />
                </Protected>
              }
            />
          </Route>

          <Route
            path="/admin"
            element={
              <Protected requireAdmin>
                <AdminLayout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="users" element={<Users />} />
            <Route path="teams" element={<Teams />} />
            <Route path="players" element={<Players />} />
            <Route path="events" element={<Events />} />
            <Route path="bookings" element={<Bookings />} />
            <Route path="products" element={<Products />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="lists" element={<Lists />} />
            <Route path="signup-fields" element={<SignupFields />} />
            <Route path="campaigns" element={<Campaigns />} />
            <Route path="join-requests" element={<JoinRequests />} />
            <Route path="contact-messages" element={<ContactMessages />} />
            <Route path="news-posts" element={<NewsPosts />} />
            <Route path="meetings" element={<Meetings />} />
            <Route path="settings/stripe" element={<StripeSettings />} />
            <Route path="settings/email" element={<EmailSettings />} />
            <Route path="settings/rental" element={<RentalPricing />} />
          </Route>

          <Route path="*" element={<div className="p-8">Not found.</div>} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
